var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['main-navbar', 'bg-white', _vm.stickyTop ? 'sticky-top' : '']},[_c('d-navbar',{staticClass:"align-items-stretch flex-md-nowrap p-0",attrs:{"type":"light"}},[_c('navbar-search'),_c('branch-switcher'),_c('navbar-nav'),_c('navbar-toggle')],1),(_vm.$store.state.settings.activeMembersCount > _vm.maxAllowedActiveMembers - 10)?_c('notification-bar-message',{attrs:{"message":_vm.$t('validations.exceedsLimitsForActiveMembers') +
      ' (' +
      _vm.$store.state.settings.activeMembersCount +
      '/' + _vm.maxAllowedActiveMembers +
      ') '}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }